// extracted by mini-css-extract-plugin
export default {"white":"light-dark(#ffffff, #000839)","amber":"#ff814d"};